export const getMaterialColors = (mainColorHash: string) => {
    const colors = {
        50: shadeColor(mainColorHash, 0.9),
        100: shadeColor(mainColorHash, 0.7),
        200: shadeColor(mainColorHash, 0.5),
        300: shadeColor(mainColorHash, 0.333),
        400: shadeColor(mainColorHash, 0.166),
        base: shadeColor(mainColorHash, 0),
        700: shadeColor(mainColorHash, -0.25),
        800: shadeColor(mainColorHash, -0.375),
        900: shadeColor(mainColorHash, -0.5),
    };

    return colors;
};

export const shadeColor = (colorHash: string, percent: number): string => {
    const colorHex = parseInt(colorHash.substring(1), 16);
    const shade = percent < 0 ? 0 : 255;
    const positivePercent = Math.abs(percent);

    /* eslint-disable no-bitwise */
    const red = colorHex >> 16;
    const green = (colorHex >> 8) & 0x00ff;
    const blue = colorHex & 0x0000ff;
    /* eslint-enable no-bitwise */

    const redShade = Math.round((shade - red) * positivePercent) + red;
    const greenShade = Math.round((shade - green) * positivePercent) + green;
    const blueShade = Math.round((shade - blue) * positivePercent) + blue;

    return `#${toColorHash(redShade)}${toColorHash(greenShade)}${toColorHash(blueShade)}`.toUpperCase();
};

const toColorHash = (color: number): string => color.toString(16).padStart(2, '0');
